import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-11bf86ec"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "offline_stock_import"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "base_details_title_button"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tb_title"
}, "导入综合活动码", -1));

const _hoisted_6 = {
  class: "base_details_content_second"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode(" 将Excel表格拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, null, -1));

import BackTitleView from "@com/BackTitleView.vue";
import { UploadFilled } from '@element-plus/icons-vue';
import $ from "@util/base";
import { ref } from "vue";
import { UPLOAD_FILE_URL } from "@net/url";
import auth from "@net/auth";
import { $msg } from "@ui/msg";
import useRoute from "@util/router";
import api from "@api/giftCode";
const name = 'file_data';
export default {
  __name: 'ImportGiftCode',

  setup(__props) {
    const route = useRoute();
    const giftCodeFormRef = ref(null);
    const accountOptions = ref([]);
    const giftCodeForm = ref({
      salesman: null
    });
    const giftCodeFormRules = {
      salesman: [{
        required: true,
        message: '请选择发放人员',
        trigger: 'change'
      }]
    };
    getConfig();

    function getConfig() {
      api.account(val => {
        accountOptions.value = val;
      });
    }

    const url = UPLOAD_FILE_URL; // 上传文件字段名

    const headers = {
      accessToken: auth.getToken()
    };
    const file = ref(null);

    function downloadTemplate() {
      api.downloadTemplate(val => {
        $.download(val.url, "导入综合活动码模板");
      });
    }

    function uploadSuccess(response) {
      if (response.code === 0) {
        file.value = response.data.fileUrl;
      }
    }

    function checkForm() {
      giftCodeFormRef.value.validate(valid => {
        if (valid) {
          if ($.isEmpty(file.value)) {
            $msg.error("请上传Excel表格");
          } else {
            api.import({
              giftCode: route.query().code,
              salesman: giftCodeForm.value.salesman,
              filePath: file.value
            }, val => {
              $msg.succ("导入成功");
              back();
            });
          }
        }
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: "导入综合活动码"
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_button, {
            type: "primary",
            onClick: downloadTemplate
          }, {
            default: _withCtx(() => [_createTextVNode("下载模板")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
            ref_key: "giftCodeFormRef",
            ref: giftCodeFormRef,
            model: giftCodeForm.value,
            rules: giftCodeFormRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发放人员",
              prop: "salesman"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: giftCodeForm.value.salesman,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => giftCodeForm.value.salesman = $event),
                placeholder: "请选择",
                filterable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), _createVNode(_component_el_upload, {
            ref: "upload",
            action: _unref(url),
            accept: ".xls,.xlsx",
            name: name,
            headers: headers,
            "on-success": uploadSuccess,
            limit: 1,
            drag: ""
          }, {
            tip: _withCtx(() => [_hoisted_8]),
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload"
            }, {
              default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
              _: 1
            }), _hoisted_7]),
            _: 1
          }, 8, ["action"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: checkForm,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};